import { FC } from 'react';
import { Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Input } from 'components/form/Input';
import { composeValidators, email, required } from 'helpers/validators';
import { OfUnion } from 'types/common';

const validateEmail = composeValidators(required, email);

export const FieldEmail: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.Email]
> = ({ fieldName, label, proposedValue }) => (
  <FormGroup marginBottom={0}>
    <Input
      field={fieldName}
      type="email"
      animatedPlaceholder={label || fieldName}
      initialValue={proposedValue || undefined}
      validate={validateEmail}
    />
  </FormGroup>
);
